<template>
  <div class="userInfo">
    <div class="userInfo_data">
      <PreviewPairData
        :label="label"
        :content="content ? content : '未登録'"
        :hasBorder="false"
      ></PreviewPairData>
    </div>

    <div class="userInfo_btn" v-if="showBtn">
      <Button
        :label="content ? '編集' : '追加登録'"
        :primary="content ? false : true"
        :lightgray="content ? true : false"
        :handleClick="
          () => {
            $emit('click-edit')
          }
        "
        sizeS
        radiusS
      />
    </div>
  </div>
</template>

<script lang="ts">
import { computed } from 'vue'
import PreviewPairData from '@/components/block/PreviewPairData.vue'
import Button from '@/components/elements/Button.vue'

export default {
  name: 'UserInformation',

  components: {
    PreviewPairData,
    Button
  },

  props: {
    name: {
      type: String,
      require: true
    },
    label: {
      type: String,
      require: true
    },
    content: {
      type: String,
      default: ''
    }
  },

  setup(props: any) {
    const showBtn = computed(() => {
      if (props.name === 'hpcr_regist_status' && props.content) return false
      if (props.name === 'doctor_regist_flg' && props.content) return false
      if (props.name === 'line' && props.content) return false
      return true
    })

    return {
      showBtn
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.userInfo {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var.$color-border-gray;
  padding-top: 2px;
  padding-bottom: 2px;

  &_data {
    width: 100%;
    flex-shrink: 1;
  }

  &_btn {
    // flex: 100% 0 0;
    flex-shrink: 0;
    margin-left: 16px;
  }
}
</style>
